import React from "react";
import { createUseStyles } from "react-jss";
import { Grid, IconButton, Tooltip, Select, MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import NavigationTabs from "./NavigationTabs";
import { useDispatch, useSelector } from "react-redux";
import { loadPorfolioInformation } from "redux/portfolioInformation/portfolioInformationFunctions";
import { RootState } from "redux/rootReducer";
import { loadYieldPerTimespans } from "redux/yieldPerTimespan/yieldPerTimespanFunctions";
import { loadUserPermissions } from "redux/user/userFunctions";
import { selectUserPermission } from "redux/user/userActions";
import { getReportDateSelector } from "redux/user/user";
import { UserPermission } from "types/UserPermission";
import { removeState } from "redux/oidc/oidcFunctions";
import { useHistory } from "react-router-dom";
import HeaderLogoMobile from "./HeaderLogoMobile";
import Background from "img/Background.png";
import { VisibleSections } from "types/VisibleSections";

const useStyles = createUseStyles({
  container: {
    minHeight: 78,
    width: "100%",
    position: "static",
    backgroundImage: `url(${Background})`,
    backgroundSize: "cover",
  },
  top: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    marginLeft: 12,
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bottom: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  line: {
    height: "100%",
    paddingLeft: 1,
    paddingRight: 1,
    background: "#FFFFFF",
  },
  whiteColor: {
    color: "#FFFFFF !important",
  },
});

const MainHeaderMobile = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const history = useHistory();

  const reportControlId = useSelector((state: RootState) => state.user.reportControlId);
  const reportDate = useSelector(getReportDateSelector);

  const showIndex = useSelector(
    (state: RootState) =>
      (state.user.visibleSections?.data as VisibleSections | undefined)?.NaytaTuotto ?? false
  );

  React.useEffect(() => {
    dispatch(loadUserPermissions());
    if (reportControlId && reportDate) {
      dispatch(loadPorfolioInformation(reportControlId, reportDate));
      dispatch(loadYieldPerTimespans(reportControlId, reportDate, showIndex));
    }
  }, [dispatch, reportControlId, reportDate, showIndex]);

  const userPermissions = useSelector(
    (state: RootState) => state.user.userPermissions?.data as UserPermission[] | undefined
  );

  const userPermissionsSorted = React.useMemo(
    () => userPermissions?.sort((a, b) => (a.Name ?? "").localeCompare(b.Name ?? "")),
    [userPermissions]
  );

  return (
    <div className={classes.container}>
      <Grid container justifyContent="center">
        <Grid item container xs={2} justifyContent="space-between">
          <HeaderLogoMobile />
          <div className={classes.line}></div>
        </Grid>
        <Grid item xs={10}>
          <Grid
            container
            item
            xs={12}
            style={{
              padding: "5px 0",
            }}
          >
            <Grid container item xs={10} alignContent="center">
              <Select
                classes={{
                  icon: classes.whiteColor,
                }}
                style={{
                  color: "#FFFFFF",
                  marginLeft: 10,
                  fontSize: "min(max(.8em, 3vw), 1em)",
                }}
                disableUnderline
                inputProps={{ style: { color: "#FFFFFF" } }}
                value={reportControlId ?? ""}
                onChange={(event) => {
                  dispatch(selectUserPermission(event.target.value as string));
                }}
              >
                {userPermissionsSorted?.map((p) => (
                  <MenuItem key={p.ReportControlId} value={p.ReportControlId}>
                    {p.Name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid container item xs={2} justifyContent="center">
              <Tooltip title={t<string>("logout")} aria-label={t("logout")}>
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => {
                    dispatch(removeState());
                    history.push("/logout");
                  }}
                >
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 7.55932L17 4V34L9 29.9322V7.55932Z"
                      stroke="#FFFFFF"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17 7.5L23 7.5V15.5M17 29.5H23V22.5"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <ellipse cx="14.5" cy="18.5" rx="0.5" ry="1" fill="#FFFFFF" />
                    <path
                      d="M20 18.5H30M30 18.5L27 15.5M30 18.5L27 21.5"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid item sm={12} style={{ overflowY: "hidden" }}>
            <NavigationTabs />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(MainHeaderMobile);
